import React from 'react';
import { Outlet } from 'react-router-dom';
import Box from '@mui/material/Box';
import Header from '../common/header';
import Footer from '../common/footer';

const PublicLayout: React.FC = () => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Header />

      {/* Main content */}
      <Box
        sx={{
          flexGrow: 1,
          width: '100%',
        }}
      >
        <Outlet />
      </Box>

      <Footer />
    </Box>
  );
};

export default PublicLayout;
